import React from "react";
import { SmoothScroll } from "../components/SmoothScroll";
import { Intro } from "../components/Intro";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/sections/Hero";
import { About } from "../components/sections/About";
import { Services } from "../components/sections/Services";
import { Testimonials } from "../components/sections/Testimonials";
import { Contact } from "../components/sections/Contact";
import { Footer } from "../components/Footer";
import { useContent } from "../context/ContentContext";

export default function Home() {
  const { content, loading } = useContent();

  if (loading || !content) {
    return (
      <div className="min-h-screen bg-void flex items-center justify-center">
        <div className="font-display text-2xl text-gold animate-pulse">Mixing Dreams</div>
      </div>
    );
  }

  return (
    <SmoothScroll>
      <Intro />
      <div className="bg-void">
        <Navbar />
        <main>
          <Hero data={content} />
          <About data={content} />
          <Services data={content} />
          <Testimonials data={content} />
          <Contact data={content} />
        </main>
        <Footer data={content} />
      </div>
    </SmoothScroll>
  );
}
